import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable, shareReplay } from 'rxjs';

import { Keyword } from '../models/keyword';

import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class KeywordsService {
  httpClient: HttpClient = inject(HttpClient);
  configService: ConfigService = inject(ConfigService);

  cachedKeysKeywords$: Observable<Record<string, string[]>> | undefined;
  cachedKeysArea$: Observable<Record<string, string[]>> | undefined;

  getHost(): string {
    return this.configService.getConfiguration().apiHost;
  }

  getAllKeywords(): Observable<Keyword[]> {
    // Non-cached call for admin panel
    return this.httpClient.get<Keyword[]>(this.getHost() + '/api/keywords/allkeywords');
  }

  getKeywordById(id: string): Observable<Keyword> {
    return this.httpClient.get<Keyword>(this.getHost() + '/api/keyword/' + id);
  }

  deleteKeyword(id: string): Observable<Keyword> {
    this.clearKeywordCache();
    return this.httpClient.delete<Keyword>(this.getHost() + '/api/keywords/deletekeyword/' + id);
  }

  saveKeyword(doc: Keyword): Observable<Keyword> {
    this.clearKeywordCache();
    return this.httpClient.post<Keyword>(this.getHost() + '/api/keywords/savekeyword', doc);
  }

  clearKeywordCache(): void {
    this.cachedKeysKeywords$ = undefined;
  }

  getCachedKeywordsList(): Observable<Record<string, string[]>> {
    this.cachedKeysKeywords$ =
      this.cachedKeysKeywords$ ||
      this.getAllKeywords()
        .pipe(
          map((data: Keyword[]) => {
            // transform to name->value pairs, remove unnecessary data
            const keywordCache: Record<string, string[]> = {};
            data.forEach((kw: Keyword) => {
              keywordCache[kw.keywordName] = kw.keywordValues.map((keyWord) => keyWord.keywordValueName) || [];
            });
            return keywordCache;
          })
        )
        .pipe(shareReplay()); // this will keep the values cached
    return this.cachedKeysKeywords$;
  }

  getBackendVersion(): Observable<Record<string, string>> {
    return this.httpClient.get<Record<string, string>>(this.getHost() + '/api/version');
  }
}
